import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  TimePicker,
} from 'antd';
import { FaUsers } from 'react-icons/fa6';
import { DownOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  addAppointments,
  getAppointmentsDetails,
  getSearchPatients,
  updateAppointments,
} from '../../../network/appointment';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ChangeStauts from '../../../hooks/ChangeStauts';
import Heading from '../../common/Heading/Heading';
import AccountsList from './AccountsList';
import {
  addCustomer,
  getCustomerById,
  getCustomerData,
  updateCustomer,
} from '../../../network/customer';
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from 'react-phone-number-input';
import HeadingApp from '../../../hooks/HeadingApp';
import CustomerAddition from './CustomerAddition';
import { convert } from 'html-to-text';
const AddCustomer = ({ t, edit }) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [searchTxt, setSearchTxt] = useState('');
  const [searchTxtPricelist, setSearchTxtPricelist] = useState('');
  const [searchTxtBankAccount, setSearchTxtBankAccount] = useState('');
  const [searchTxtAccountManager, setSearchTxtAccountManager] = useState('');
  const [searchTxtAddress, setSearchTxtAddress] = useState('');
  const [searchTxtCurrency, setSearchTxtCurrency] = useState('');
  const [dataSource, setDataSource] = useState([{}]);
  const watchcustomerType = Form.useWatch('customer_type', form);
  const [dataSourceAddition, setDataSourceAddition] = useState([
    {
      key: 0,
      type_name: 'Tax Identification Number',
      type_code: 'TIN',
    },
    {
      key: 1,
      type_name: 'Commercial Registration Number',
      type_code: 'CRN',
    },
    {
      key: 2,
      type_name: 'MOMRAH License',
      type_code: 'MOM',
    },
    {
      key: 3,
      type_name: 'MHRSD License',
      type_code: 'MLS',
    },
    {
      key: 4,
      type_name: '700 Number',
      type_code: '700',
    },
    {
      key: 5,
      type_name: 'MISA License',
      type_code: 'SAG',
    },
    {
      key: 6,
      type_name: 'National ID',
      type_code: 'NAT',
    },
    {
      key: 7,
      type_name: 'GCC ID',
      type_code: 'GCC',
    },
    {
      key: 8,
      type_name: 'Iqama',
      type_code: 'IQA',
    },
    {
      key: 9,
      type_name: 'Passport ID',
      type_code: 'PAS',
    },
    {
      key: 10,
      type_name: 'Other ID',
      type_code: 'OTH',
    },
  ]);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const client = useQueryClient();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const watchCustomerType = Form.useWatch('customer_type', form);
  const { companyName } = useSelector((state) => state.user);
  const { mutate: onAddCustomer } = useMutation({
    mutationKey: ['onAddCustomer'],
    mutationFn: (body) => (edit ? updateCustomer(body, id) : addCustomer(body)),
    onSuccess: (data) => {
      console.log(data, 'datawwww');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getCustomer] });
      form.resetFields();
      navigate('/customers');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      console.log(messageData, 'messageData');

      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });

  const onFinish = (values) => {
    if (watchcustomerType === 'Company') {
      const hasAtLeastOneValue = dataSourceAddition.some(
        (item) => item?.value && item?.value.trim() !== ''
      );
      if (!hasAtLeastOneValue) {
        // message.error('Please enter at least one Additional Ids.');
        message.error(t.please_enter_at_least_one_additional_ids);
        setLoadingAdd(false);
        return;
      }
    }
    setLoadingAdd(true);
    onAddCustomer({
      ...values,
      customer_group: 'All Customer Groups',
      territory: 'All Territories',
      accounts: dataSource?.map((item) => ({
        account: item?.account,
        company: companyName,
      })),
      custom_additional_ids: dataSourceAddition?.map((item) => ({
        type_name: item?.type_name,
        type_code: item?.type_code,
        value: item?.value,
      })),
    });
  };
  const { data: bankAccount, isLoading: isLoadingBankAccount } = useQuery({
    queryKey: [queryKeys.getSearchBankAccount, searchTxtBankAccount],
    queryFn: () => getSearchPatients('Bank Account', searchTxtBankAccount),
    enabled:
      searchTxtBankAccount?.length >= 2 || searchTxtBankAccount?.length === 0,
    keepPreviousData: true,
  });
  const { data: accountManager, isLoading: isLoadingAccountManager } = useQuery(
    {
      queryKey: [queryKeys.getSearchAccountManager, searchTxtAccountManager],
      queryFn: () => getSearchPatients('User', searchTxtAccountManager),
      enabled:
        searchTxtAccountManager?.length >= 2 ||
        searchTxtAccountManager?.length === 0,
      keepPreviousData: true,
    }
  );
  const { data: addressList, isLoading: isLoadingAddress } = useQuery({
    queryKey: [queryKeys.getSearchAddress, searchTxtAddress],
    queryFn: () => getSearchPatients('Address', searchTxtAddress),
    enabled: searchTxtAddress?.length >= 2 || searchTxtAddress?.length === 0,
    keepPreviousData: true,
  });
  const { data: pricelist, isLoading: isLoadingPricelist } = useQuery({
    queryKey: [queryKeys.getSearchPricelist, searchTxtPricelist],
    queryFn: () => getSearchPatients('Price List', searchTxtPricelist),
    enabled:
      searchTxtPricelist?.length >= 2 || searchTxtPricelist?.length === 0,
    keepPreviousData: true,
  });
  const { data: currency, isLoading: isLoadingCurrency } = useQuery({
    queryKey: [queryKeys.getSearchCurrency, searchTxtCurrency],
    queryFn: () => getSearchPatients('Currency', searchTxtCurrency),
    enabled: searchTxtCurrency?.length >= 2 || searchTxtCurrency?.length === 0,
    keepPreviousData: true,
  });
  const { data: customerDetails, isLoading: isLoadingAppointments } = useQuery({
    queryKey: [queryKeys.getCustomer, id],
    queryFn: () => getCustomerById(id),
    keepPreviousData: true,
    enabled: !!edit,
  });
  const { data: customerData } = useQuery({
    queryKey: [queryKeys.getCustomerData, companyName],
    queryFn: () => getCustomerData(companyName),
    keepPreviousData: true,
    enabled: !!companyName,
  });

  useEffect(() => {
    if (customerData) {
      setDataSource([
        {
          account: customerData?.message?.default_receivable_account,
        },
      ]);
    }
  }, [companyName, customerData]);
  useEffect(() => {
    if (edit && customerDetails?.data) {
      setDataSource(customerDetails?.data?.accounts);
      form.setFieldsValue({
        ...customerDetails?.data,
      });
      setDataSourceAddition(
        customerDetails?.data?.custom_additional_ids?.length > 0
          ? customerDetails?.data?.custom_additional_ids
          : [
              {
                key: 0,
                type_name: 'Tax Identification Number',
                type_code: 'TIN',
              },
              {
                key: 1,
                type_name: 'Commercial Registration Number',
                type_code: 'CRN',
              },
              {
                key: 2,
                type_name: 'MOMRAH License',
                type_code: 'MOM',
              },
              {
                key: 3,
                type_name: 'MHRSD License',
                type_code: 'MLS',
              },
              {
                key: 4,
                type_name: '700 Number',
                type_code: '700',
              },
              {
                key: 5,
                type_name: 'MISA License',
                type_code: 'SAG',
              },
              {
                key: 6,
                type_name: 'National ID',
                type_code: 'NAT',
              },
              {
                key: 7,
                type_name: 'GCC ID',
                type_code: 'GCC',
              },
              {
                key: 8,
                type_name: 'Iqama',
                type_code: 'IQA',
              },
              {
                key: 9,
                type_name: 'Passport ID',
                type_code: 'PAS',
              },
              {
                key: 10,
                type_name: 'Other ID',
                type_code: 'OTH',
              },
            ]
      );
    }
  }, [customerDetails]);

  if (isLoadingAppointments) {
    return (
      <div
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="appointment-add">
      {/* <Heading
        title={t.Customer}
        subTitle={edit ? t.editCustomer : t.addCustomer}
        path="/customers"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.Customer}
        subTitle={edit ? t.editCustomer : t.addCustomer}
        icon={<FaUsers />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="customer_name"
                    label={t.customerName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.customerName} />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    // name="customer_name_in_arabic"
                    name="zatca_customer_name_in_arabic"
                    label={t.customerNameInArabic}
                  >
                    <Input placeholder={t.customerNameInArabic} />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="custom_email"
                    label={t.email}
                    rules={[
                      // {
                      //   required: true,
                      // },
                      {
                        type: 'email',
                      },
                    ]}
                  >
                    <Input placeholder={t.email} type="email" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="customer_type"
                    label={t.customerType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    initialValue={'Company'}
                  >
                    <Select
                      placeholder={t.customerType}
                      options={[
                        {
                          value: 'Company',
                          label: t.company,
                        },
                        {
                          value: 'Individual',
                          label: t.individual,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="custom_buyer_id_type"
                    label={t.customBuyerIdType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.customBuyerIdType}
                      options={[
                        {
                          value: 'TIN',
                          label: 'TIN',
                        },
                        {
                          value: 'CRN',
                          label: 'CRN',
                        },
                        {
                          value: 'MOM',
                          label: 'MOM',
                        },
                        {
                          value: 'MLS',
                          label: 'MLS',
                        },
                        {
                          value: 'SAG',
                          label: 'SAG',
                        },
                        {
                          value: 'NAT',
                          label: 'NAT',
                        },
                        {
                          value: 'GCC',
                          label: 'GCC',
                        },
                        {
                          value: 'IQA',
                          label: 'IQA',
                        },
                        {
                          value: 'PAS',
                          label: 'PAS',
                        },
                        {
                          value: 'OTH',
                          label: 'OTH',
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="custom_buyer_id"
                    label={t.customBuyerId}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input placeholder={t.customBuyerId} type="number" />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="custom_vat_registration_number"
                    label={t.custom_vat_registration_number}
                    rules={[
                      {
                        required:
                          watchcustomerType === 'Company' ? true : false,
                      },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();

                          const stringValue = String(value);

                          if (!/^\d{15}$/.test(stringValue)) {
                            return Promise.reject(
                              t.Numbermustbe15digits
                              // 'الرقم يجب أن يكون مكون من 15 رقمًا'
                            );
                          }

                          if (!stringValue.startsWith('3')) {
                            // return Promise.reject('الرقم يجب أن يبدأ بـ 3');
                            return Promise.reject(t.Numbermuststartwith3);
                          }

                          if (!stringValue.endsWith('3')) {
                            return Promise.reject(t.Numbermustendwith3);
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder={t.custom_vat_registration_number}
                      type="number"
                    />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="tax_id"
                label={t.taxId}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input placeholder={t.taxId} type="number" />
              </Form.Item>
            </Col> */}
                {/* <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="custom_id_cr"
                label={
                  watchCustomerType === 'Company'
                    ? t.CommercialRegistryNumber
                    : t.IdNumber
                }
              >
                <Input
                  placeholder={
                    watchCustomerType === 'Company'
                      ? t.CommercialRegistryNumber
                      : t.IdNumber
                  }
                  type="number"
                />
              </Form.Item>
            </Col> */}
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="default_price_list"
                    label={t.priceList}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.priceList}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtPricelist(value);
                      }}
                      filterOption={false}
                      loading={isLoadingPricelist}
                    >
                      {pricelist?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="default_bank_account"
                    label={t.bankAccount}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.bankAccount}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtBankAccount(value);
                      }}
                      filterOption={false}
                      loading={isLoadingBankAccount}
                    >
                      {bankAccount?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="default_currency"
                    label={t.currency}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    initialValue={'SAR'}
                  >
                    <Select
                      placeholder={t.currency}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtCurrency(value);
                      }}
                      filterOption={false}
                      loading={isLoadingCurrency}
                    >
                      {currency?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col sm={12} md={12} lg={12} xxl={12}>
                  <Form.Item
                    name="custom_mobile_number"
                    label={t.mobile}
                    className="w-full"
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    //   {
                    //     validator: (rule, value) => {
                    //       console.log(value, 'value');
                    //       if (isValidPhoneNumber(value)) {
                    //         return Promise.resolve();
                    //       }
                    //       return Promise.reject('رقم الجوال غير صالح');
                    //     },
                    //   },
                    // ]}
                    hasFeedback
                  >
                    <PhoneInputWithCountrySelect
                      defaultCountry="SA"
                      className="w-full"
                      name="custom_mobile_number"
                      label={t.mobile}
                      international
                      hasFeedback
                      limitMaxLength={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="account_manager"
                    label={t.accountManager}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.accountManager}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtAccountManager(value);
                      }}
                      filterOption={false}
                      loading={isLoadingAccountManager}
                    >
                      {accountManager?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="customer_primary_address"
                    label={t.customer_primary_address}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.customer_primary_address}
                      showSearch
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtAddress(value);
                      }}
                      filterOption={false}
                      loading={isLoadingAddress}
                    >
                      {addressList?.message?.map((item) => (
                        <Select.Option key={item?.value} value={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col
                  xs={24}
                  md={12}
                  xl={12}
                  xxl={12}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_b2c"
                    // label={t.custom_b2c}
                    // rules={[{ required: true }]}
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.custom_b2c}</Checkbox>
                  </Form.Item>
                </Col> */}
                <Divider orientation="left">{t.customerAccounts}</Divider>
                <Col span={24}>
                  <AccountsList
                    t={t}
                    form={form}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    account={
                      customerData?.message?.default_receivable_account || ''
                    }
                  />
                </Col>
                <Divider orientation="left">{t.AdditionalIds}</Divider>
                <Col span={24}>
                  <CustomerAddition
                    t={t}
                    form={form}
                    setDataSource={setDataSourceAddition}
                    dataSource={dataSourceAddition}
                  />
                </Col>
                {/* <Divider orientation="left">{t.CustomerAddress}</Divider>
                <Col span={24}>
                  <Form.Item name="customer_details" label={t.CustomerAddress}>
                    <Input.TextArea
                      autoSize={{ minRows: 4, maxRows: 5 }}
                      placeholder={t.CustomerAddress}
                    />
                  </Form.Item>
                </Col> */}
                {edit ? (
                  <>
                    <Divider orientation="left">{t.primaryAddress}</Divider>
                    <Col span={24}>
                      <Form.Item
                        // name="primary_address"
                        label={t.primaryAddress}
                      >
                        <Input.TextArea
                          disabled
                          autoSize={{ minRows: 4, maxRows: 5 }}
                          placeholder={t.primaryAddress}
                          value={
                            customerDetails?.data?.primary_address
                              ? customerDetails.data.primary_address.replace(
                                  /<br\s*\/?>/gi,
                                  '\n'
                                )
                              : ''
                          }
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loadingAdd}
                  // block
                >
                  {edit ? t.edit + ' ' + t.customer : t.add + ' ' + t.customer}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default AddCustomer;
